import { Step } from "react-joyride";

export const getSettingsTourSteps = (): Step[] => [
  {
    target: '.settings-header',
    content: 'Gestiona tu perfil y preferencias desde aquí.',
    placement: 'center',
  },
  {
    target: '.profile-section',
    content: 'Actualiza tu información personal.',
    placement: 'bottom',
  },
  {
    target: '.gym-section',
    content: 'Gestiona tu membresía y código de gimnasio.',
    placement: 'bottom',
  },
  {
    target: '.cambiocontraseña',
    content: 'Cambia tu contraseña y ajustes de seguridad.',
    placement: 'top',
  },
  {
    target: '.bg-card.p-1.rounded-xl',
    content: 'Personaliza la apariencia de la aplicación.',
    placement: 'top',
  },
  {
    target: '.setting-clase',
    content: 'Gestiona las clases en el gimnasio.',
    placement: 'right',
  },
  {
    target: '.setting-admin',
    content: 'Aquí puedes gestionar los gimnasios que administras.',
    placement: 'bottom',
  },
  /*necesario?
  {
    target: '.gym-list',
    content: 'Lista de gimnasios bajo tu administración.',
    placement: 'bottom',
  },
  {
    target: '.gym-actions',
    content: 'Acciones disponibles para cada gimnasio como editar, eliminar y gestionar usuarios.',
    placement: 'top',
  }*/
];